import React, { Component } from "react";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import partial from "lodash/partial";
import SubcategorySelect from "common/containers/subcategory_select";

const POPULAR_SLUGS = [
  "logo-design",
  "website-design",
  "naming-a-business-or-product",
  "product-design",
];

export default class HomeSubcatSelect extends Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(id) {
    const { subCategories } = this.props;
    const subCat = subCategories.find((s) => s.id === id);
    browserHistory.push(`/${subCat.slug}/`);
  }

  render() {
    const { subCategories } = this.props;

    return (
      <div className="hero-actions sub-category-select">
        <h2>I need a</h2>
        <div className="header-select">
          <SubcategorySelect
            meta={{}}
            input={{
              name: "sub_category",
              onChange: this.handleSelect,
            }}
          />
        </div>
        <div className="popular">
          <strong>Popular:</strong>
          <br className="show-for-small-only" />
          {POPULAR_SLUGS.map((slug) => {
            const subcat = subCategories.find((s) => s.slug === slug);
            return (
              <span
                key={slug}
                className="tag tag-default tag-sm"
                onClick={partial(this.handleSelect, subcat.id)}
              >
                {subcat.name}
              </span>
            );
          })}
        </div>
      </div>
    );
  }
}
